import { S3Client, GetObjectCommand } from "@aws-sdk/client-s3";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";

const AWS_CONFIG = {
  region: process.env.REACT_APP_AWS_REGION || "eu-south-2",
  endpoint: process.env.REACT_APP_AWS_ENDPOINT || "https://s3.eu-south-2.amazonaws.com",
  credentials: {
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID || "",
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY || ""
  }
};

const BUCKET_NAME = process.env.REACT_APP_BUCKET_NAME || "yonna-live";
const BUCKET_ROOT = `https://${BUCKET_NAME}.s3.${AWS_CONFIG.region}.amazonaws.com/`;

export const getSignedUrlForFile = async (file_key: string, expiry_seconds?: number): Promise<string> => {
  try {
    if (!file_key) {
      throw new Error('file_key is required');
    }
    const expiresIn = Math.min(expiry_seconds || 3600, 604800);

    // Ensure file_key includes bucket name in the path
    const fullKey = file_key.startsWith(BUCKET_NAME + '/') ? file_key : `${BUCKET_NAME}/${file_key}`;

    console.log('Generating signed URL for:', file_key);
    console.log('Full key:', fullKey);
    console.log('Bucket:', BUCKET_NAME);
    console.log('Region:', AWS_CONFIG.region);

    const s3Client = new S3Client({
      region: AWS_CONFIG.region,
      credentials: {
        accessKeyId: AWS_CONFIG.credentials.accessKeyId,
        secretAccessKey: AWS_CONFIG.credentials.secretAccessKey
      }
    });

    const command = new GetObjectCommand({
      Bucket: BUCKET_NAME,
      Key: fullKey
    });

    // Generate signed URL
    const signedUrl = await getSignedUrl(s3Client, command, { expiresIn });
    console.log('Signed URL generated successfully');

    return signedUrl;
  } catch (error) {
    console.error('Error generating signed URL, using fallback:', error)
    // Return direct S3 URL as fallback
    return `${BUCKET_ROOT}${file_key}`;
  }
};


export const getImageSignedUrl = async (file_key: string): Promise<string> => {
  try {
    if (!file_key) {
      return '';
    }

    const signedUrl = await getSignedUrlForFile(file_key);
    console.log(signedUrl);
    return signedUrl;
  } catch (error) {
    console.error('Error getting image signed URL:', error);
    // Return direct S3 URL as fallback
    return `${BUCKET_ROOT}${file_key}`;
  }
};


export const getInvoiceSignedUrl = async (invoice_key: string, expiry_seconds?: number): Promise<string> => {
  try {
    if (!invoice_key) {
      throw new Error('invoice_key is required');
    }

    console.log('Generating signed URL for invoice:', invoice_key);
    
    const expiresIn = Math.min(expiry_seconds || 3600, 604800);

    let cleanKey = invoice_key;
    if (invoice_key.startsWith(BUCKET_NAME + '/')) {
      cleanKey = invoice_key.substring(BUCKET_NAME.length + 1);
    }

    console.log('Invoice key:', invoice_key);
    console.log('Clean key (without bucket):', cleanKey);
    console.log('Bucket:', BUCKET_NAME);
    
    const s3Client = new S3Client({
      region: AWS_CONFIG.region,
      credentials: {
        accessKeyId: AWS_CONFIG.credentials.accessKeyId,
        secretAccessKey: AWS_CONFIG.credentials.secretAccessKey
      }
    });

    const command = new GetObjectCommand({
      Bucket: BUCKET_NAME,
      Key: cleanKey
    });

    const signedUrl = await getSignedUrl(s3Client, command, { expiresIn });
    
    console.log('Invoice signed URL generated successfully');
    return signedUrl;
  } catch (error) {
    console.error('Error getting invoice signed URL:', error);
    return `${BUCKET_ROOT}${invoice_key}`;
  }
};